// @flow
import React from "react";
import styled from "styled-components";

const CheckmarkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  border: 1px solid;
  border-color: ${(props) => (props.value ? props.primaryColor : "#000000")};
  background-color: ${(props) =>
    props.value ? props.primaryColor : "#FFFFFF"};
  transition: all 0.24s ease-in;
  cursor: pointer;
`;

const Checkmark = styled.div`
  display: inline-block;

  :after {
    content: "";
    position: relative;
    bottom: 2px;
    display: block;
    width: 4px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

type CheckboxProps = {
  value: boolean,
  onChange: () => any,
  primaryColor: string
};

class Checkbox extends React.PureComponent<CheckboxProps> {
  renderCheckmark = () => <Checkmark />;
  render() {
    return (
      <CheckmarkContainer
        className="checkbox__container__se"
        onClick={this.props.onChange}
        {...this.props}
      >
        {this.props.value && this.renderCheckmark()}
      </CheckmarkContainer>
    );
  }
}

export default Checkbox;
